var map = {
	"./awards/0.jpg": "9e29",
	"./awards/1.jpg": "91f2",
	"./awards/2.jpg": "399e",
	"./awards/3.jpg": "a55f",
	"./awards/4.jpg": "e957",
	"./awards/5.jpg": "840c",
	"./banner-1.jpg": "eeea",
	"./banner-2.jpg": "e78d",
	"./banner-3.jpg": "5b39",
	"./contact-weixin.jpg": "36a4",
	"./curiosity.jpg": "efd3",
	"./curiosity.mp4": "ab55",
	"./curiosity.webm": "6cc3",
	"./investor-0.png": "93a5",
	"./investor-1.png": "172a",
	"./investor-2.png": "a0fd",
	"./jobs/智联/临床监察员.jpg": "017e",
	"./jobs/智联/分子病毒研究员.jpg": "3348",
	"./jobs/智联/分子研究员.jpg": "a7ee",
	"./jobs/智联/研发QC.jpg": "f44a",
	"./jobs/智联/细胞治疗研究员.jpg": "8553",
	"./jobs/智联/药物分析员.jpg": "5bf5",
	"./jobs/智联/药理研究员.jpg": "129b",
	"./jobs/猎聘/临床监察员.jpg": "3080",
	"./jobs/猎聘/分子病毒研究员.jpg": "2696",
	"./jobs/猎聘/分子研究员.jpg": "fa7b",
	"./jobs/猎聘/研发QC.jpg": "8a78",
	"./jobs/猎聘/细胞治疗研究员.jpg": "9d5b",
	"./jobs/猎聘/药物分析员.jpg": "fb3f",
	"./jobs/猎聘/药理研究员.jpg": "c736",
	"./logo-h-white.svg": "1f29",
	"./logo-h.svg": "3556",
	"./news/20201202_1.jpg": "55f7",
	"./news/20201202_2.jpg": "4d8b",
	"./news/20201220_1.jpg": "b1b8",
	"./news/20201220_2.jpg": "807b",
	"./news/20201220_3.jpg": "63ea",
	"./news/20210420_1.jpg": "78bf",
	"./news/20210619_1.jpg": "788f",
	"./news/20210619_2.png": "77ae",
	"./news/20210619_3.png": "c63f",
	"./news/20211011_1.png": "64f6",
	"./news/20211011_2.png": "a0e3",
	"./news/20211011_3.png": "1b03",
	"./news/20211012_1.png": "2190",
	"./news/20211012_2.jpg": "a1db",
	"./news/20211013_1.jpg": "8614",
	"./news/20211013_2.jpg": "c9ba",
	"./news/20211013_3.png": "43a4",
	"./news/20211013_4.png": "0b78",
	"./news/20220117_1.jpg": "ac8a",
	"./news/20220802_1.jpg": "74f2",
	"./portraits/Hugh_Davis.png": "5d51",
	"./portraits/Ron_Weiss.png": "55d9",
	"./portraits/刘乙齐.png": "e2ed",
	"./portraits/刘庆华.png": "ed1f",
	"./portraits/刘建.png": "3418",
	"./portraits/古槿.png": "b020",
	"./portraits/张学工.png": "9a5b",
	"./portraits/彭曙光.png": "1505",
	"./portraits/李梢.png": "ff69",
	"./portraits/汪小我.png": "fad0",
	"./portraits/蒋云.png": "ba99",
	"./portraits/谢震.png": "85de",
	"./portraits/赵海涛.png": "4dea",
	"./portraits/陆荫英.png": "c7dc",
	"./portraits/陈彬.png": "932a",
	"./portraits/黄慧雅.png": "ff6b",
	"./science-0.png": "58da",
	"./science-1.jpg": "5d21",
	"./synbio-0.png": "9272",
	"./synbio-1.png": "f87d",
	"./title-font.ttf": "5591"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";